import useHeaders from "../utils/useHeaders";
import { URI_API } from "../utils/api";

const getAllCategories = async () => {
  return await fetch(`${URI_API}/category/all`, {
    method: "GET",
    headers: useHeaders.getHeaders(),
  }).then((res) => res.json());
};

const getAllActiveCategories = async () => {
  return await fetch(`${URI_API}/category/all_active`, {
    method: "GET",
    headers: useHeaders.getHeaders(),
  }).then((res) => res.json());
}

const createCategory = async (body: any) => {
  return await fetch(`${URI_API}/category/create`, {
    method: "POST",
    headers: useHeaders.getHeaders(),
    body: JSON.stringify(body),
  }).then((res) => res.json());
}

const editCategory = async (categoryId: number, body: any) => {
  return await fetch(`${URI_API}/category/edit/${categoryId}`, {
    method: "PUT",
    headers: useHeaders.getHeaders(),
    body: JSON.stringify(body),
  }).then((res) => res.json());
}

const deactivateCategory = async (categoryId: number) => {
  return await fetch(`${URI_API}/category/deactivate/${categoryId}`, {
    method: "PUT",
    headers: useHeaders.getHeaders(),
  }).then((res) => res.json());
}

export default {
    getAllCategories,
    getAllActiveCategories,
    createCategory,
    editCategory,
    deactivateCategory
};